module.exports = "/_next/static/images/cb614f9df678aa76e926b4a02c9272ff-open-graph-logo-large-br.png.webp";